/**
 * Header: open dropdown / mega menus on hover.
 *
 * Enabled by the "Open dropdowns on hover" header setting, which adds
 * `data-menu-hover` to `.header__nav`. The compiled theme bundle only opens
 * submenus on click (toggling the `visible` class on `[data-submenu]`); this
 * script mirrors that state on mouse hover for devices that actually have a
 * hover-capable pointer. Touch devices and keyboard users keep the theme's
 * click / focus behaviour untouched.
 *
 * Everything is delegated at document level so it survives section
 * re-renders in the theme editor.
 */
(function () {
  if (window.__skuHeaderHoverMenu) return;
  window.__skuHeaderHoverMenu = true;

  var NAV_SELECTOR = '.header__nav[data-menu-hover]';
  var PARENT_SELECTOR = 'li[data-submenu-parent]';
  var CLOSE_DELAY = 250; // ms — bridges the gap between trigger and submenu
  var hoverMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
  var closeTimers = new WeakMap();

  function hoverActive(target) {
    if (!hoverMedia.matches) return null;
    if (!target || typeof target.closest !== 'function') return null;
    return target.closest(NAV_SELECTOR);
  }

  function directChild(parent, selector) {
    for (var i = 0; i < parent.children.length; i++) {
      if (parent.children[i].matches(selector)) return parent.children[i];
    }
    return null;
  }

  function submenuOf(li) {
    return directChild(li, '[data-submenu]');
  }

  function triggerOf(li) {
    return directChild(li, '[data-parent]');
  }

  function isOpen(li) {
    var menu = submenuOf(li);
    return !!menu && menu.classList.contains('visible');
  }

  function cancelClose(li) {
    var timer = closeTimers.get(li);
    if (timer) {
      clearTimeout(timer);
      closeTimers.delete(li);
    }
  }

  function closeMenu(li) {
    cancelClose(li);
    var menu = submenuOf(li);
    var trigger = triggerOf(li);
    if (!menu) return;

    // Close any nested submenus still open inside this one.
    menu.querySelectorAll(PARENT_SELECTOR).forEach(function (nested) {
      if (isOpen(nested)) closeMenu(nested);
    });

    menu.classList.remove('visible');
    menu.setAttribute('aria-hidden', 'true');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function openMenu(li) {
    cancelClose(li);
    var menu = submenuOf(li);
    var trigger = triggerOf(li);
    if (!menu) return;

    // Only one sibling submenu open at a time.
    Array.prototype.forEach.call(li.parentNode.children, function (sibling) {
      if (sibling !== li && sibling.matches(PARENT_SELECTOR) && isOpen(sibling)) {
        closeMenu(sibling);
      }
    });

    menu.classList.add('visible');
    menu.setAttribute('aria-hidden', 'false');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function scheduleClose(li) {
    cancelClose(li);
    closeTimers.set(
      li,
      setTimeout(function () {
        closeTimers.delete(li);
        closeMenu(li);
      }, CLOSE_DELAY)
    );
  }

  function parentChain(nav, from) {
    var chain = [];
    var li = from && from.closest ? from.closest(PARENT_SELECTOR) : null;
    while (li && nav.contains(li)) {
      chain.push(li);
      li = li.parentElement ? li.parentElement.closest(PARENT_SELECTOR) : null;
    }
    return chain;
  }

  document.addEventListener('mouseover', function (e) {
    var nav = hoverActive(e.target);
    if (!nav) return;

    parentChain(nav, e.target).forEach(function (li) {
      cancelClose(li);
      if (!isOpen(li)) openMenu(li);
    });
  });

  document.addEventListener('mouseout', function (e) {
    var nav = hoverActive(e.target);
    if (!nav) return;

    var to = e.relatedTarget;
    parentChain(nav, e.target).forEach(function (li) {
      if (!to || !li.contains(to)) scheduleClose(li);
    });
  });

  // With hover open/close in place, a click on a parent link should follow
  // its URL instead of toggling the submenu closed again. The theme bundle
  // binds its toggle handler directly on the link, so stop the event in the
  // capture phase before it gets there. Links without a real URL ("#") keep
  // the theme's toggle behaviour.
  document.addEventListener(
    'click',
    function (e) {
      var nav = hoverActive(e.target);
      if (!nav) return;

      var link = e.target.closest('a[data-parent]');
      if (!link || !nav.contains(link)) return;

      var href = link.getAttribute('href');
      if (!href || href === '#') return;

      e.stopPropagation();
    },
    true
  );
})();
